import { render, staticRenderFns } from "./mpModule3.vue?vue&type=template&id=7c9918cb&scoped=true"
import script from "./mpModule3.vue?vue&type=script&lang=js"
export * from "./mpModule3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9918cb",
  null
  
)

export default component.exports